import React from "react";
import clsx from "clsx";

import AttentionIcon from "@material-ui/icons/ReportProblemOutlined";
import { isExpirationWarning } from "../helper";

import useStyles from "./styles";

interface IProps {
  reactivationDays: number;
}

const ExpirationDays = (props: IProps) => {
  const { reactivationDays } = props;

  const classes = useStyles();

  const isHighAttention = isExpirationWarning(reactivationDays);

  return (
    <div className={classes.root}>
      <span
        className={clsx(classes.expirationCount, {
          [classes.highAttention]: isHighAttention
        })}
      >
        {reactivationDays}
      </span>
      <span className={classes.attentionIconWrapper}>
        {isHighAttention && <AttentionIcon className={classes.attentionIcon} />}
      </span>
    </div>
  );
};

export default React.memo(ExpirationDays);
